import dayjs from "dayjs";
import { Button } from "../../../../../../components/Button";
import { LineData } from "../../../../../../components/LineData";
import { type ExpertDomain } from "../../../../../../types/domain/expert-domain";
import { getYesOrNoTextByBoolean } from "../../../../../../utils/getYesOrNoTextByBoolean";
import { getPersonTypeTranslate } from "../../../utils/getPersonTypeTranslate";
import { validateLinkedinUrl } from "../../../../../../utils/validateLinkedinUrl";
import { ReactComponent as LinkedinSvg } from "../../../../../../assets/svgs/linkedin.svg";
import { ReactComponent as WhatsAppSvg } from "../../../../../../assets/svgs/whatsapp-alt.svg";

interface Props {
  data?: ExpertDomain;
  edit: () => void;
}

export const LegalPersonData = ({ data, edit }: Props) => {
  return (
    <div>
      {/* CNPJ */}
      <LineData label="CNPJ" text={data?.legalData?.cnpj} />

      {/* Razão Social */}
      <LineData label="Razão Social" text={data?.legalData?.companyName} />

      {/* Nome */}
      <LineData label="Nome completo" text={data?.name} />

      <LineData
        label="Tipo do expert"
        text={getPersonTypeTranslate(data?.personType ?? "")}
      />

      {/* Contato (Email/Telefone) */}
      <div className="flex flex-col md:flex-row md:gap-14">
        <LineData label="E-mail" text={data?.email} />
        <div className="flex flex-col md:flex-row md:gap-1">
          <LineData label="Telefone" text={data?.phone} />
          {data?.phone != "" && (
            <a
              href={`https://wa.me/${data?.phone}`}
              className="text-primary-light mb-3 md:mb-0"
              target="_blank"
              rel="noopener noreferrer"
            >
              <WhatsAppSvg width={25} height={25} />
            </a>
          )}
        </div>
      </div>

      {/* LinkedIn */}
      <div className="flex flex-col md:flex-row md:gap-1">
        <LineData label="LinkedIn" text={data?.linkedin} />
        {data?.linkedin && validateLinkedinUrl(data?.linkedin) && (
          <a
            href={data?.linkedin}
            className="text-primary-light md:mt-1 mb-3 md:mb-0"
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkedinSvg width={20} height={20} />
          </a>
        )}
      </div>

      {/* CEP */}
      <LineData label="CEP" text={data?.naturalData?.cep} />

      {/* Rua */}
      <LineData label="Rua" text={data?.naturalData?.street} />

      {/* Endereço (Número/Complemento) */}
      <div className="flex flex-col md:flex-row md:gap-14">
        <LineData label="Número" text={data?.naturalData?.addressNumber} />
        <LineData
          label="Complemento"
          text={data?.naturalData?.complement || ""}
        />
      </div>

      {/* Endereço (Bairro/Cidade/Estado) */}
      <div className="flex flex-col md:flex-row md:gap-14">
        <LineData label="Bairro" text={data?.naturalData?.neighborhood} />
        <LineData label="Cidade" text={data?.naturalData?.city} />
        <LineData label="Estado" text={data?.naturalData?.state} />
      </div>

      {/* Research associate / Data de cadastro) */}
      <div className="flex flex-col md:flex-row md:gap-14 ">
        <LineData label="Research associate" text={data?.researcher?.name} />
        <LineData
          label="Data de cadastro"
          text={`${dayjs(data?.createdAt).format("DD/MM/YYYY")}`}
        />
      </div>

      {/* Research acronym) */}
      <div className="flex flex-col md:flex-row md:gap-14 ">
        <LineData
          label="Último contato realizado por"
          text={data?.researcherAcronym}
        />
      </div>

      {/* agreeParticipateMeet */}
      <LineData
        label={"Aceita participar de reunião"}
        text={getYesOrNoTextByBoolean(data?.agreeParticipateMeet)}
      />

      {/* doNotContactTemporarily */}
      <LineData
        label={"Bloqueado para contato temporário"}
        text={getYesOrNoTextByBoolean(data?.doNotContactTemporarily)}
      />

      {/* Último contato */}
      <LineData label="Último contato" text={data?.lastContactAt} />

      <Button variant="outline" className="mt-10" onClick={edit}>
        Editar
      </Button>
    </div>
  );
};
